import anywhere from 'assets/img/icons/features/anywhere.svg';
import dynamic from 'assets/img/icons/features/dynamic.svg';
import claims from 'assets/img/icons/features/claims.svg';
import support from 'assets/img/icons/features/support.svg';
import Curve from './components/Curve';
import CustomParallaxImage from './components/CustomParallaxImage';
import {
  Background,
  FeaturesContainer,
  Feature,
  FeatureIcon,
  FeatureTitle,
  FeatureBody
} from './styled';

const Features = () => {
  return (
    <Background>
      <Curve />
      <FeaturesContainer>
        <Feature delay={100}>
          <FeatureIcon src={anywhere} />
          <FeatureTitle>Hire people anywhere</FeatureTitle>
          <FeatureBody>
            Remote Health insurance works globally, so you can hire the best talent in the
            world, regardless of company size and team member locations.
          </FeatureBody>
        </Feature>
        <Feature delay={200}>
          <FeatureIcon src={dynamic} />
          <FeatureTitle>Dynamic like your team</FeatureTitle>
          <FeatureBody>
            Add team members at any time, whether they are on a full-time salary, a
            part-time contract or somewhere in between.
          </FeatureBody>
        </Feature>
        <Feature delay={300}>
          <FeatureIcon src={claims} />
          <FeatureTitle>Fast, reliable and easy claims</FeatureTitle>
          <FeatureBody>
            Fill out a quick online form and get paid back in 21 days or less. For
            expensive procedures, we can send the payment to the provider.
          </FeatureBody>
        </Feature>
        <Feature delay={400}>
          <FeatureIcon src={support} />
          <FeatureTitle>Support you can rely on</FeatureTitle>
          <FeatureBody>
            Your team gets dedicated 24/7 support from day one. You’ll always speak to a
            human and we reply within a minute in live chat.
          </FeatureBody>
        </Feature>
      </FeaturesContainer>
      <CustomParallaxImage />
    </Background>
  );
};

export default Features;
